
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-2xl font-bold text-emerald-600" style={{ fontFamily: 'Pacifico, serif' }}>
              IRN
            </div>
            <div className="text-lg font-semibold text-gray-800">
              Integrated Recovery Network
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              About Us
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Services
            </Link>
            <Link to="/impact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Our Impact
            </Link>
            <Link to="/get-involved" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Get Involved
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Contact
            </Link>
            <Link to="/get-involved">
              <Button variant="primary" size="sm">
                Support Us
              </Button>
            </Link>
          </nav>

          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-emerald-600 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-emerald-600 font-medium cursor-pointer">
                Home
              </Link>
              <Link to="/about" className="text-gray-700 hover:text-emerald-600 font-medium cursor-pointer">
                About Us
              </Link>
              <Link to="/services" className="text-gray-700 hover:text-emerald-600 font-medium cursor-colors cursor-pointer">
                Services
              </Link>
              <Link to="/impact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Our Impact
              </Link>
              <Link to="/get-involved" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Get Involved
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Contact
              </Link>
              <Link to="/get-involved">
                <Button variant="primary" size="sm" className="w-full">
                  Support Us
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
